import Description from '@/components/prayer-request/description.vue';
<template>
  <div class="mt-5 bg-white px-10 py-6 rounded-md md:mt-0 md:col-span-2">
    <form @submit.prevent>
      <h2 class="text-xl md:text-3xl mb-5 font-bold">♥️ Submit Testimony</h2>

      <!-- Inputs -->
      <b-field label="Name">
        <b-input
          type="text"
          placeholder="e.g. John Doe"
          aria-placeholder="e.g. John Doe"
          v-model="name"
          required
        />
      </b-field>
      <b-field label="Email Address">
        <b-input
          required
          type="email"
          placeholder="e.g. email@example.com"
          aria-placeholder="e.g. email@example.com"
          v-model="email"
        />
      </b-field>
      <b-field label="Title">
        <b-input
          type="text"
          placeholder="My testimony"
          aria-placeholder="My testimony"
          v-model="title"
          required
        />
      </b-field>
      <b-field class="mt-5" label="Testimony">
        <b-input
          placeholder="Describe your testimony"
          aria-placeholder="Testimony description"
          type="textarea"
          v-model="description"
        />
      </b-field>

      <div class="text-xs text-orange-600 mb-4">
        By clicking submit, you consent to Phaneroo Ministries International holding and using your information for follow up and communication purposes. Note that your personal information will not be shared publicly.
      </div>

      <div class="flex justify-end">
        <b-button
          @click="$emit('close')"
          type="is-light"
          class="mr-2"
        >
          Cancel
        </b-button>
        <b-button
          @click="createTestimony"
          type="is-primary"
        >
          Submit
        </b-button>
      </div>
      <b-loading :active.sync="isLoading" :is-full-page="false" />
    </form>
  </div>
</template>

<script>

export default {
  name: 'PrayerRequestForm',
  data () {
    return {
      name: '',
      email: '',
      title: '',
      description: '',
      isLoading: false
    }
  },
  methods: {
    /**
     * Creates a new testimony
     */
    async createTestimony () {
      this.isLoading = true
      try {
        await this.$store.dispatch('testimonies/createTestimony', {
          title: this.title,
          content: this.description,
          email: this.email,
          name: this.name
        })

        this.$emit('testimony:created')
        this.$emit('close')
      } catch (error) {
        this.$logger.error('Error creating testimony', error)
        this.$notify('There was a problem submitting your testimony. ' + error.message, {
          type: 'error',
          title: 'Error creating testimony',
          duration: 5000
        })
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
